export default __webpack_public_path__ + "static/media/star.b0844577.svg";